// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"mp-z","slideIn":"np-z"};